import { render, staticRenderFns } from "./BoxInspectionsTableDetails.vue?vue&type=template&id=e148a706&scoped=true"
import script from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
export * from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./BoxInspectionsTableDetails.vue?vue&type=style&index=0&id=e148a706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e148a706",
  null
  
)

export default component.exports